module.exports = __webpack_public_path__ + "img/calidad_fondo.8409dd5f.jpg";